import { QueryStatus } from "@reduxjs/toolkit/query";
import { useSelector } from "react-redux";
import type { AppState } from "../store";

export const useUtils = () => {
	const { mutations } = useSelector((state: AppState) => state.onboardingApi);

	const loadingMutations = Object.keys(mutations).filter(
		(key) => mutations[key]?.status === QueryStatus.pending,
	);

	return {
		isMutationLoading: Boolean(loadingMutations.length),
	};
};
